module.exports = __webpack_public_path__ + "static/media/cloudIcon.9f7bba28.svg";